import { render, staticRenderFns } from "./StaffItem.vue?vue&type=template&id=1178288b&scoped=true&"
import script from "./StaffItem.vue?vue&type=script&lang=ts&"
export * from "./StaffItem.vue?vue&type=script&lang=ts&"
import style0 from "./StaffItem.vue?vue&type=style&index=0&id=1178288b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1178288b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1178288b')) {
      api.createRecord('1178288b', component.options)
    } else {
      api.reload('1178288b', component.options)
    }
    module.hot.accept("./StaffItem.vue?vue&type=template&id=1178288b&scoped=true&", function () {
      api.rerender('1178288b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/components/StaffItem.vue"
export default component.exports